import React, { Component } from 'react';
import { AnnouncementModalLayout, WixDesignSystemProvider } from '@wix/design-system';
import { t } from '../../../utils/i18n';
import '@wix/design-system/styles.global.css';

const WIX_DASHBOARD = 'https://www.wix.com/dashboard';

class NoPaymentMethodUser extends Component<{ msid: string }, null> {
  closeWidget = () => {
    (window as any).Wix.closeWindow();
  };
  onClickPrimary = () => {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      href: `${WIX_DASHBOARD}/${this.props.msid}/payments/`,
    }).click();
  };
  render() {
    const img = `${window.__STATICS_BASE_URL__}/assets/img/pay-method.svg`;

    return (
      <WixDesignSystemProvider>
        <AnnouncementModalLayout
          title={t('paymentMethods.noConnectedProvidersUser.title')}
          content={t('paymentMethods.noConnectedProvidersUser.description')}
          primaryButtonText={t('paymentMethods.noConnectedProvidersUser.button')}
          primaryButtonOnClick={this.onClickPrimary}
          onCloseButtonClick={this.closeWidget}
          illustration={img}
        />
      </WixDesignSystemProvider>
    );
  }
}

export default NoPaymentMethodUser;
